import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

const CohortFilterAnd = ({
  first,
  isEditing,
}) => (
  <>
    {!first ? (
      <span
        className={clsx('aridhia-cohort-and help', !isEditing && 'aridhia-cohort-and--noedit')}
      >
        <FormattedMessage id="cohort.refine.and" />
      </span>
    ) : null }
  </>
);

export default CohortFilterAnd;
